import React from 'react';
import classnames from 'classnames';
import VisitorInfo from '../../visitor-info';

import style from './index.less';

const { ItemRow, VisitorInfoList: List, EditableCell, FormEditableCell } = VisitorInfo;

type EmptyTipProps = {
  className?: string;
  tip: string | JSX.Element;
};

const EmptyTip = ({ className, tip = '暂无数据' }: EmptyTipProps): JSX.Element => (
  <div className={classnames(className, style['empty-tip'])}>{tip}</div>
);

export { EmptyTip, ItemRow, List, EditableCell, FormEditableCell };
